export default __webpack_public_path__ + "static/media/Commercial-Paper-EN.ad8fd5a9.png";